import { fetchEventSource } from '@microsoft/fetch-event-source';
import axios from 'axios';
import { auth } from '../../../firebase';
import { PendingActionItem } from '../../Interfaces/system/PendingActions.interfaces';

const apiUrl = process.env['NX_API_URL'];

export const fetchPendingActions = async (
  companyID?: string,
  process?: string
): Promise<PendingActionItem[]> => {
  const response = await axios.get(`${apiUrl}/api/pending_actions`, {
    params: { companyID, process },
    headers: {
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
  });
  return response.data;
};

export const openPendingActionsStream = (
  onMessage: (data: unknown) => void,
  onError?: () => void
): AbortController => {
  const controller = new AbortController();

  fetchEventSource(`${apiUrl}/api/pending_actions/stream`, {
    signal: controller.signal,
    openWhenHidden: true,
    async fetch(input, init) {
      const token = await auth.currentUser?.getIdToken();
      return window.fetch(input, {
        ...init,
        headers: { ...init?.headers, Authorization: `Bearer ${token}` },
      });
    },
    onmessage(event) {
      try {
        onMessage(JSON.parse(event.data));
      } catch {
        // ignore malformed events
      }
    },
    onerror(err) {
      if (controller.signal.aborted) throw err;
      onError?.();
    },
  });

  return controller;
};
